import { render, staticRenderFns } from "./Anuncio.vue?vue&type=template&id=9c0ccb50&scoped=true&"
import script from "./Anuncio.vue?vue&type=script&lang=js&"
export * from "./Anuncio.vue?vue&type=script&lang=js&"
import style0 from "./Anuncio.vue?vue&type=style&index=0&id=9c0ccb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0ccb50",
  null
  
)

export default component.exports